import React from 'react';
import { volumes } from '../data/svenska';

// Neutral placeholders drawn with CSS while the SVENSKA KLAR image slots (MOCKUP_URL, PAGE_URLS in data/svenska.ts) are empty.
export function ProductBoxPlaceholder({
  className = ''
}: {
  className?: string;
}) {
  return <div role="img" aria-label="SVENSKA KLAR™ – 6 digitala volymer i svenska för åk 1–9" className={`relative mx-auto w-full max-w-sm ${className}`} data-id="element-263" data-mp="1es60hkbhg81c">
      <div className="rounded-2xl bg-[#1B2A5E] p-5 text-white shadow-2xl shadow-slate-900/30" data-id="element-264" data-mp="15uvofwqucevd">
        <p className="text-xs font-semibold uppercase tracking-widest text-white/70" data-id="element-265" data-mp="10tpw4013etmd">Åk 1–9 · Lgr22</p>
        <p className="mt-1 font-serif text-4xl leading-none tracking-tight" data-id="element-266" data-mp="vwpnbhcuzcrk">SVENSKA KLAR<span className="align-super text-[0.45em]" data-id="element-267" data-mp="qx3ava4uu0jt">™</span></p>
        <p className="mt-2 text-sm leading-snug text-white/80" data-id="element-268" data-mp="qyxyiw7ig6rl">Läsa · Skriva · Tala · Språklära</p>
        <div className="mt-5 grid grid-cols-6 gap-1.5" data-id="element-269" data-mp="2q7bhzug9wb50">
          {volumes.map(v => <div key={v.number} className={`flex h-36 flex-col justify-between rounded-md border-r-4 border-black/10 p-1.5 ${v.spine}`} data-id="element-270" data-mp="2lb48xsskyjiu">
              <span className="text-[9px] font-bold opacity-80" data-id="element-271" data-mp="2y5hcwejemsyy">{v.number.replace('Volym ', 'V')}</span>
              <span className="origin-bottom-left -rotate-90 translate-x-3 whitespace-nowrap text-[10px] font-semibold" data-id="element-272" data-mp="2j8gi225x2hw9">{v.level}</span>
            </div>)}
        </div>
        <p className="mt-4 text-center text-sm font-semibold text-[#FECC02]" data-id="element-273" data-mp="2o7jo9pxmuu5t">6 volymer + 5 bonusar</p>
      </div>
    </div>;
}
export function PagePlaceholder({
  label,
  title
}: {
  label: string;
  title: string;
}) {
  return <div className="flex h-full w-full flex-col bg-white" aria-hidden="true" data-id="element-274" data-mp="3gxtaknz4562r">
      <div className="flex items-center justify-between bg-[#1B2A5E] px-4 py-3 text-white" data-id="element-275" data-mp="326stjukaw3v0">
        <span className="text-[11px] font-bold uppercase tracking-widest" data-id="element-276" data-mp="374ks37fgao86">SVENSKA KLAR™</span>
        <span className="flex h-6 w-6 items-center justify-center rounded-full bg-[#FF8A7A] text-[10px] font-bold text-[#1B2A5E]" data-id="element-277" data-mp="3uu6v65yy1nlg">1</span>
      </div>
      <div className="flex flex-1 flex-col gap-3 p-5" data-id="element-278" data-mp="dcsrypxqnzj4">
        <p className="text-[11px] font-bold uppercase tracking-widest text-[#2BB673]" data-id="element-279" data-mp="dc9naax3n7n1">{label}</p>
        <p className="font-serif text-xl leading-tight text-slate-900" data-id="element-280" data-mp="8ehn6tmawf7r">{title}</p>
        {[0, 1, 2, 3, 4, 5, 6].map(i => <div key={i} className="h-2.5 rounded-full bg-slate-900/10" style={{
        width: `${92 - i * 7}%`
      }} data-id="element-281" data-mp="4eh4uxw2zjvf" />)}
        <div className="mt-auto grid grid-cols-3 gap-2" data-id="element-282" data-mp="3vl0dc6eg2xqk">
          <div className="h-14 rounded-md bg-[#006AA7]/20" data-id="element-283" data-mp="3qkcq7vtc711m" />
          <div className="h-14 rounded-md bg-[#FECC02]/30" data-id="element-284" data-mp="3lt4e2s0mh1kr" />
          <div className="h-14 rounded-md bg-[#FF8A7A]/25" data-id="element-285" data-mp="3lrjlh7xvbspj" />
        </div>
      </div>
    </div>;
}